import { doGet, doPost2 } from 'services/common'

//Utility function to run JSON.parse without failing method, due to some returned data inconsistencies
const isJSON = str => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

// export const enterSweepstake = (sweepsId, ticketCount) => {

//     const body = {
//         'ticketsPurchased': ticketCount,
//         'sweepsPrizeId': sweepsId
//     }

//     return doPost('/sweeps/enter', body)

// }

export const enterSweepstake = async (sweepsId, ticketCount) => {
  const body = {
    ticketsPurchased: ticketCount,
    sweepsPrizeId: sweepsId,
  }

  // console.log(params)

  // return doPost(`/user/register`, params)
  try {
    const response = await doPost2(`/sweeps/enter`, body)

    return response.text().then(data => {
      if (response.status !== 200) {
        // return {
        //     status: response.status,
        //     success: response.ok,
        //     detail: isJSON(data) ? JSON.parse(data) : data
        // }
        return new Promise((resolve, reject) => {
          reject({
            status: response.status,
            success: response.ok,
            detail: isJSON(data) ? JSON.parse(data) : data,
          })
        })
      } else {
        return {
          status: response.status,
          success: response.ok,
          detail: isJSON(data) ? JSON.parse(data) : data,
        }
      }
    })
  } catch (e) {
    return new Promise((resolve, reject) => {
      // eslint-disable-line no-unused-vars
      reject({
        success: false,
        status: -1,
        message:
          'Unable to communicate with server. Please check your internet connection.',
      })
    })
  }
}

//TODO - theres actually a /user/getsweepsentries - dont need to go through getprofile
export const getEntryCount = async sweepsPrizeId => {
  // try {
  //     const userInfo = await getProfileInfo();
  //     const sweepsEntry = userInfo.detail.sweepsEntries.find(entry => entry.sweepsPrizeId === sweepsPrizeId)
  //     return sweepsEntry ? sweepsEntry.ticketCount : false;
  // } catch (e) {
  //     return e;
  // }
}

export const getSweepsDrawingDetails = sweepsId => {
  return doGet(`/sweeps/${sweepsId}`)
}
